import { useI18n } from "../i18n/LanguageContext";

/**
 * EU regulatory / marketing disclaimers (MiFID II style). Reused on the
 * Plans page, the yield calculator and the footer to keep the wording
 * consistent across the portal in all four locales.
 */
export default function ComplianceDisclaimers({ className = "" }) {
  const { t } = useI18n();
  const items = [t("disc.past"), t("disc.risk"), t("disc.mkt")];
  return (
    <div
      className={`br-card px-6 py-5 ${className}`}
      style={{
        background: "rgba(167,128,73,0.04)",
        borderLeft: "2px solid var(--br-bronze)",
      }}
      data-testid="compliance-disclaimers"
    >
      <div
        className="font-mono-fin text-[0.6rem] tracking-[0.24em] uppercase"
        style={{ color: "var(--br-bronze)" }}
      >
        {t("disc.title")}
      </div>
      <ul className="mt-3 space-y-1.5 text-[0.74rem] leading-relaxed text-[color:var(--br-text-dim)]">
        {items.map((it, i) => (
          <li key={i} data-testid={`disclaimer-item-${i}`}>
            · {it}
          </li>
        ))}
      </ul>
    </div>
  );
}
